export default (userInfo) =>
	userInfo &&
	userInfo.attributes &&
	userInfo.attributes['custom:is_impersonator'] &&
	userInfo.attributes['custom:is_impersonator'] !== 'false';
